import { getInstrument, historicalApiHost } from "../Config";
export const fetchHistoricalData = async (identifier, symbol, user_id) => {
  const identifierUrl = historicalApiHost[`${identifier}`]
  const date = new Date();
  date.setUTCHours(0, 0, 0, 0);
  const formattedDate = date.toISOString();
  console.log(formattedDate);

  console.log(`formattedDate hai bhai ${formattedDate} and ${identifierUrl}`)
  try {
    const response = await fetch(`${identifierUrl}/CandleData/CandleRequest?Name=${symbol}&FromDate=${formattedDate}`);
    if (response) {
      const jsonData = await response.json();
      const formattedData = jsonData.map(item => ({
        time: Math.floor(new Date(item.date).getTime() / 1000),
        open: item.open,
        high: item.high,
        low: item.low,
        close: item.close,
      }));
      formattedData.sort((a, b) => a.time - b.time);
      return formattedData
    }
    else {
      console.log("something went a wrong")
    }
  } catch (error) {
    console.log("error when accessing a historical data", error);

  }
};



export const FetchInstrument = async (userID,identifer) => {
  const url=getInstrument[`${identifer}`]
  try {
    const data = { userId: userID };
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await fetch(url, options);
    const responseData = await response.json();
    console.log(responseData);
  
    return responseData
  } catch (error) {
    console.error("Error fetching instrument:", error);
  }

}



